/**************************************************
 * Nombre:       Formulario_Programa_Razones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useIngresarObjeto} from "../../../Modulo_formularios/Hooks/useIngresarObjeto";
import Tarjetas_Informacion from "../../Tarjeta/Tarjetas_Informacion";
import Formulario_Programa_Razones_Razones from "./Formulario_Programa_Razones_Razones";

const Formulario_Programa_Razones = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        nombre: 'Agregar Razon',
        dato: 'razones',
        Tarjeta: Tarjetas_Informacion,
        Formulario: Formulario_Programa_Razones_Razones,
    });

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresarObjeto/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Programa_Razones